import { DOCUMENT } from '@angular/common';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: '[login-selector]',
  template: require('./login-selector.component.pug'),
  styles: [require('./login-selector.component.css').toString()],
})
export class LoginSelectorComponent implements OnInit, OnDestroy {
  csrf = '';

  // -------------------------------------------------------------------
  constructor(
    @Inject(DOCUMENT) private document: any,
    private http: HttpClient,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.csrf = this.document.querySelector("meta[name='csrf-token']").content;
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {}
}
